import { formDataType } from "../AddSite";
import React from "react";
import styles from "../add-site.module.css";
import { InputSwitch } from "primereact/inputswitch";
import { Calendar } from "primereact/calendar";
import { SiteDefaultSchedule } from "../../../../models/site.interface";

interface ScheduleProps {
  formData: formDataType;
  setFormData: React.Dispatch<React.SetStateAction<formDataType>>;
}

export function Schedule({ formData, setFormData }: ScheduleProps) {
  function handleScheduleUpdate(day: string, field: string, value: any) {
    setFormData(prev => ({
      ...prev,
      default_schedule: {
        ...prev.default_schedule,
        [day as keyof SiteDefaultSchedule]: {
          ...(prev.default_schedule as any)[day],
          [field]: value,
        },
      },
    }));
  }
  return (
    <div className={styles["responsive-grid-2"] + " my-4"}>
      {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].map(
        (day, index) => {
          const { active, start, end } =
            formData.default_schedule[day as keyof SiteDefaultSchedule];
          return (
            <div key={day} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "100px 80px 1fr 1fr",
                  gap: "0.75rem",
                  alignItems: "start",
                }}
              >
                {/* Day Name */}
                <h4 style={{ margin: 0, fontWeight: 600, color: "#333", fontSize: "1rem" }}>
                  {day.charAt(0).toUpperCase() + day.slice(1)}
                </h4>

                {/* Active Toggle */}
                <div>
                  <label
                    style={{
                      fontWeight: 600,
                      display: "block",
                      marginBottom: "0.25rem",
                      color: "#333",
                      fontSize: "0.75rem",
                    }}
                  >
                    Status
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.25rem",
                      marginTop: 8,
                    }}
                  >
                    <InputSwitch
                      checked={active}
                      onChange={e => {
                        handleScheduleUpdate(day, "active", e.value);
                      }}
                      style={{ transform: "scale(0.8)" }}
                    />
                  </div>
                </div>

                {/* Start Time */}
                <div>
                  <label
                    style={{
                      fontWeight: 600,
                      display: "block",
                      marginBottom: "0.25rem",
                      color: active ? "#333" : "#999",
                      fontSize: "0.75rem",
                    }}
                  >
                    Start Time
                  </label>
                  <Calendar
                    value={active && start ? new Date(`2024-01-01 ${start}`) : null}
                    onChange={e => {
                      if (e.value) {
                        const timeString = e.value.toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        });
                        handleScheduleUpdate(day, "start", timeString);
                      }
                    }}
                    timeOnly
                    showTime
                    hourFormat="24"
                    stepMinute={15}
                    disabled={!active}
                    style={{ width: "100%", fontSize: "0.8rem" }}
                    placeholder="Start time"
                  />
                </div>

                {/* End Time */}
                <div>
                  <label
                    style={{
                      fontWeight: 600,
                      display: "block",
                      marginBottom: "0.25rem",
                      color: active ? "#333" : "#999",
                      fontSize: "0.75rem",
                    }}
                  >
                    End Time
                  </label>
                  <Calendar
                    value={active && end ? new Date(`2024-01-01 ${end}`) : null}
                    onChange={e => {
                      if (e.value) {
                        const timeString = e.value.toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        });
                        handleScheduleUpdate(day, "end", timeString);
                      }
                    }}
                    timeOnly
                    showTime
                    hourFormat="24"
                    stepMinute={15}
                    disabled={!active}
                    style={{ width: "100%", fontSize: "0.8rem" }}
                    placeholder="End time"
                  />
                </div>
              </div>

              {/* Divider - Show after every day except the last */}
              {index <
                ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]
                  .length -
                  1 && (
                <hr
                  style={{
                    border: "none",
                    borderTop: "1px solid #dee2e6",
                    margin: "0.5rem 0",
                  }}
                />
              )}
            </div>
          );
        }
      )}
    </div>
  );
}
